import { themeConfig, themePreset } from '@/themeConfig'

const state = {
  themeMode: themeConfig,
  vuetifyPreset: themePreset,
}

const getters = {
  getThemeMode: state => state.themeMode,
  getVuetifyPreset: state => state.vuetifyPreset,
}

const actions = {
  changeVerticalSidebarDrawer ({ commit }) {
    commit('toggleVerticalSidebarDrawer')
  },

  changeVerticalSidebarMini ({ commit }) {
    commit('toggleVerticalSidebarMini')
  },

  changeThemeLoadingState ({ commit }, payload) {
    commit('toggleThemeLoadingState', payload)
  },
}

const mutations = {
  toggleVerticalSidebarDrawer (state) {
    state.themeMode.verticalSidebarDrawer = !state.themeMode
      .verticalSidebarDrawer
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
